import React from "react";
// import { Helmet } from "react-helmet";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import "../../sass/files/about-us.scss";

const AboutUs = () => {
  return (
    <>
      {/* Enable this after installing and configuring react-helmet */}
      {/* <Helmet>
        <title>
          About 3D Spot | Professional Custom 3D Modeling Studio
        </title>

        <meta
          name="description"
          content="Learn about 3D Spot, a professional custom 3D modeling studio creating artist-sculpted, print-ready STL files from photos, sketches, and ideas."
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://3dspot.io/about-us" />

        <meta
          property="og:title"
          content="About 3D Spot | Custom 3D Models and STL Files"
        />

        <meta
          property="og:description"
          content="We transform photos and ideas into detailed, print-ready 3D models for collectors, creators, businesses, and 3D printing enthusiasts."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://3dspot.io/about-us" />
      </Helmet> */}

      <Navbar />

      <main className="about-page">
        <section className="about-hero">
          <div className="about-container">
            <span className="about-badge">About 3D Spot</span>

            <h1 className="about-title">
              Turning Ideas and Memories Into Print-Ready 3D Models
            </h1>

            <p className="about-subtitle">
              3D Spot is a professional custom 3D modeling studio creating
              detailed, artist-refined 3D models for collectors, creators,
              businesses, and 3D printing enthusiasts around the world.
            </p>

            <div className="about-hero-actions">
              <a href="/Login" className="about-btn">
                Request a Quote
              </a>

              <a href="/gallery" className="about-btn about-btn-secondary">
                View Our Work
              </a>
            </div>
          </div>
        </section>

        <div className="about-container">
          <section className="about-section about-introduction">
            <div className="about-section-heading">
              <span className="about-eyebrow">Our Company</span>
              <h2>Who We Are</h2>
            </div>

            <div className="about-copy">
              <p>
                3D Spot specializes in transforming photographs, sketches,
                concepts, and creative ideas into professionally sculpted 3D
                models. Our work is created for real-world applications,
                including 3D printing, collectibles, personalized gifts,
                statues, miniatures, jewelry, props, and product development.
              </p>

              <p>
                Every project is handled with close attention to proportions,
                likeness, surface detail, structure, and printability. Our goal
                is to create a model that not only looks impressive on screen
                but is also properly prepared for its intended production
                process.
              </p>

              <p>
                We work with clients worldwide and provide a clear,
                collaborative process from the initial reference review to
                final file delivery.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-heading">
              <span className="about-eyebrow">Our Services</span>
              <h2>What We Create</h2>
              <p>
                Our team supports a wide range of custom modeling requirements,
                from personal projects to commercial production.
              </p>
            </div>

            <div className="about-grid">
              <article className="about-card">
                <span className="about-card-number">01</span>
                <h3>Photo to 3D Models</h3>
                <p>
                  Custom 3D models developed from photographs and visual
                  references.
                </p>
              </article>

              <article className="about-card">
                <span className="about-card-number">02</span>
                <h3>Custom Busts and Statues</h3>
                <p>
                  Personalized busts, full-body statues, and memorial models
                  created with careful attention to likeness.
                </p>
              </article>

              <article className="about-card">
                <span className="about-card-number">03</span>
                <h3>Pet Models</h3>
                <p>
                  Custom pet sculptures based on photographs, suitable for
                  keepsakes, gifts, and 3D printing.
                </p>
              </article>

              <article className="about-card">
                <span className="about-card-number">04</span>
                <h3>Characters and Collectibles</h3>
                <p>
                  Original characters, fan-inspired collectibles, miniatures,
                  and display models.
                </p>
              </article>

              <article className="about-card">
                <span className="about-card-number">05</span>
                <h3>Jewelry and Product Models</h3>
                <p>
                  Detailed digital models created for jewelry, accessories,
                  product concepts, and manufacturing requirements.
                </p>
              </article>

              <article className="about-card">
                <span className="about-card-number">06</span>
                <h3>STL Cleanup and Refinement</h3>
                <p>
                  Existing models reviewed and refined to improve form,
                  detailing, structure, and printability.
                </p>
              </article>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-heading">
              <span className="about-eyebrow">Why 3D Spot</span>
              <h2>Designed by Artists, Prepared for Production</h2>
            </div>

            <div className="about-feature-layout">
              <div className="about-copy">
                <p>
                  Creating a successful 3D model requires more than generating
                  an attractive render. The design must also account for scale,
                  thickness, balance, separation, surface detail, and the
                  limitations of the intended production method.
                </p>

                <p>
                  Our team combines artistic sculpting with practical
                  production knowledge to create dependable files that remain
                  faithful to the client’s vision.
                </p>
              </div>

              <ul className="about-list">
                <li>
                  <strong>Artist-refined modeling</strong>
                  <span>
                    Models are carefully developed and refined by experienced
                    3D artists.
                  </span>
                </li>

                <li>
                  <strong>Attention to likeness</strong>
                  <span>
                    We study the defining shapes, proportions, and details of
                    every reference.
                  </span>
                </li>

                <li>
                  <strong>Print-ready delivery</strong>
                  <span>
                    Final files are prepared according to the approved project
                    requirements.
                  </span>
                </li>

                <li>
                  <strong>Collaborative reviews</strong>
                  <span>
                    Clients receive previews and can provide feedback before
                    final delivery.
                  </span>
                </li>

                <li>
                  <strong>Confidential project handling</strong>
                  <span>
                    Client references and project information are handled
                    professionally.
                  </span>
                </li>
              </ul>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-heading">
              <span className="about-eyebrow">Our Clients</span>
              <h2>Who We Work With</h2>
              <p>
                We serve individual customers, independent creators, and
                businesses that need reliable custom 3D modeling support.
              </p>
            </div>

            <div className="client-grid">
              <div className="client-item">Collectors</div>
              <div className="client-item">3D Printing Studios</div>
              <div className="client-item">Gift Buyers</div>
              <div className="client-item">Toy and Figure Creators</div>
              <div className="client-item">Jewelry Businesses</div>
              <div className="client-item">Prop Makers</div>
              <div className="client-item">Product Designers</div>
              <div className="client-item">Independent Artists</div>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-heading">
              <span className="about-eyebrow">How It Works</span>
              <h2>Our Project Process</h2>
              <p>
                Every project follows a clear workflow so you always know what
                happens next.
              </p>
            </div>

            <div className="process-grid">
              <article className="process-card">
                <span>01</span>
                <h3>Send Your References</h3>
                <p>
                  Share your photographs, sketches, existing files, dimensions,
                  and project requirements.
                </p>
              </article>

              <article className="process-card">
                <span>02</span>
                <h3>Project Assessment</h3>
                <p>
                  We review the complexity, intended use, delivery requirements,
                  timeline, and project scope.
                </p>
              </article>

              <article className="process-card">
                <span>03</span>
                <h3>Quotation and Confirmation</h3>
                <p>
                  You receive a clear quotation and delivery estimate before
                  production begins.
                </p>
              </article>

              <article className="process-card">
                <span>04</span>
                <h3>Modeling and Sculpting</h3>
                <p>
                  Our artists build and refine the model according to the
                  approved references and requirements.
                </p>
              </article>

              <article className="process-card">
                <span>05</span>
                <h3>Preview and Feedback</h3>
                <p>
                  We share project previews so you can review the model and
                  provide feedback.
                </p>
              </article>

              <article className="process-card">
                <span>06</span>
                <h3>Final File Delivery</h3>
                <p>
                  After approval, the completed print-ready files are securely
                  delivered to you.
                </p>
              </article>
            </div>
          </section>

          <section className="about-section">
            <div className="about-section-heading">
              <span className="about-eyebrow">Our Commitment</span>
              <h2>Quality, Communication, and Accountability</h2>
            </div>

            <div className="values-grid">
              <article className="value-card">
                <h3>Quality</h3>
                <p>
                  We aim for a strong balance between artistic detail,
                  structural reliability, and the intended final use.
                </p>
              </article>

              <article className="value-card">
                <h3>Communication</h3>
                <p>
                  We maintain clear communication throughout the project and
                  keep clients informed about important progress.
                </p>
              </article>

              <article className="value-card">
                <h3>Reliability</h3>
                <p>
                  We define the project requirements before production and work
                  toward the agreed scope and delivery schedule.
                </p>
              </article>
            </div>
          </section>

          <section className="about-section about-contact">
            <div className="about-section-heading">
              <span className="about-eyebrow">Contact 3D Spot</span>
              <h2>Let’s Discuss Your Project</h2>
              <p>
                Tell us what you would like to create and share any available
                references. Our team will review your requirements and provide
                the next steps.
              </p>
            </div>

            <div className="contact-grid">
              <article className="contact-card">
                <span className="contact-label">Business Location</span>
                <h3>3D Spot</h3>
                <p>Beaverton, Oregon</p>
                <p>United States</p>
              </article>

              <article className="contact-card">
                <span className="contact-label">Email</span>
                <h3>Project Enquiries</h3>
                <a href="mailto:info@3dspot.io">info@3dspot.io</a>
              </article>

              <article className="contact-card">
                <span className="contact-label">WhatsApp</span>
                <h3>Speak With Our Team</h3>
                <a
                  href="https://wa.me/9177643908"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  +1(917) 764-3908
                </a>
              </article>
            </div>
          </section>

          <section className="about-section about-cta">
            <span className="about-eyebrow">Start Your Project</span>
            <h2>Have an Idea You Want to Bring to Life?</h2>

            <p>
              Send us your concept, photographs, or sketches and let our team
              transform them into a professionally created custom 3D model.
            </p>

            <div className="about-cta-actions">
              <a href="/Login" className="about-btn">
                Request a Quote
              </a>

              <a
                href="mailto:info@3dspot.io"
                className="about-btn about-btn-secondary"
              >
                Email Our Team
              </a>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default AboutUs;